<template>
  <v-app class="bg-app">
    <!-- START NAVIGATION BAR COMPONENT -->
    <SNavbar :drawer="drawer" />
    <!-- END NOTIFICATION COMPONENT -->
    <v-app-bar app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-row justify="end" align="center">
        <div class="mr-5">
          <AvatarMenu />
        </div>
      </v-row>
    </v-app-bar>

    <v-main class="main-content ml-3">
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
    <v-fab-transition>
      <v-btn
        @click="dialog = true"
        color="altColor"
        dark
        fixed
        bottom
        right
        fab
        large
      >
        <v-icon>fa-qrcode</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-footer app class="pa-0">
      <SFooter />
    </v-footer>

    <SAlert
      v-model="alert"
      :message="message"
      error
      type-action="normal"
      @onClose="alert = false"
    />
  </v-app>
</template>

<script>
import AvatarMenu from "@/components/avatar/AvatarMenu";

export default {
  name: "SLayout",
  components: {
    AvatarMenu,
  },
  data: () => ({
    drawer: true,
    dialog: false,
    ICON: "fa-qrcode",
    alert: false,
    successAlert: false,
    message: "",
  }),
  methods: {
    openAlert({ success, message }) {
      this.alert = true;
      this.successAlert = success;
      this.message = message;
    },
    closeDialog() {
      return (this.dialog = false);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=PT+Sans");
.bg-app[data-app="true"] {
  font-family: "PT Sans", sans-serif;
  background-image: linear-gradient(to bottom, #e7feff, #0bb7bc61) !important;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
</style>
